<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>3ENG Second Edition: Weather, Climate, and Natural Hazards - Downloads and Resources</h3>
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>

      <div class="presentations">
        <h4>Teacher Presentations</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202025%20Updates%2F3ENG-2E_Activities1-7_updated_08242026.zip?alt=media&token=e563e6fc-0cdb-4fb3-8a86-76d2142686d8" target="_blank">Teacher Presentations: Activities 1 - 7</a> - Updated 8/24/2026</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FJanuary%202026%20Updates%2F3ENG%20Second%20Edition%20-%20Technology%20Lessons-20260112T163244Z-3-001.zip?alt=media&token=5dd5d3b5-b89e-437e-8e60-c4c90b860365" target="_blank">Technology Lessons 1A-1C (Zip File) - Updated 1/12/2026</a></li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Student Journals</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1RigQ-2wxAfWSUuDbT71YseM1WVe914wDPgs8MHPcAUk/copy" target="_blank">3ENG Second Edition: Weather, Climate, and Natural Hazards Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1C05zHYfGWqGRE_dV_bu-O3TIPP7jF3aF/view" target="_blank">3ENG Second Edition: Weather, Climate, and Natural Hazards Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1RFlPJ31u5qR6PlHK8UhDK8b2-puH2ZdQsmqtF96GQrk/copy" target="_blank">3ENG Second Edition: Weather, Climate, and Natural Hazards Student Journal - SPANISH</a></li>
        </ul>

      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1-djvj5n89SKp77ZHLGkr0eTMOetK8eJMjZ7GFKjBdsg/copy" target="_blank">On the Same Day Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1g5KOp_vPYlmKr9CMJv3vpdYVM6HBFrPGShe6sDExMQI/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/17kA9Ur-ahOU1x449ajeDX6jZcsG2-PKt01uuyRbLc1o/copy" target="_blank">Word Wall</a></li>
          <li><a href="https://docs.google.com/spreadsheets/d/1q9IyGC1QqUjVaj-LuliQfoGPu15ORnZmiKhxMPoAvj4/copy" target="_blank">Class Variations in Temperature Bar Graph</a></li>
          <li><a href="https://docs.google.com/presentation/d/10MwJ-0pNjvDWuIq7mTvRhVhaHuKXpN-Nkc-j0WPQky8/copy" target="_blank">Word Sort Cards - Lesson 2D</a></li>
          <li><a href="https://docs.google.com/presentation/d/1B7liN5dyNDVwYGYZYTopKSukVWoZVd5U_6vWHXjm7kg/copy" target="_blank">Weather Vanes, Windsocks, and Anemometers (Handout)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1MXBTJCxjnC4KPC9k5fC6WQjdDBiUJdwJo_ZM4CWi5cQ/copy" target="_blank">Measuring the Wind Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1vmOM6tICX1irWaIALqSOFRH5thghDA1S9WVmTr5_mAc/copy" target="_blank">Rain Maker Observation Log (Handout)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1AH9Ii448GFwBej2I1kYNj7zQJlbC4Y8HKef6tu2apis/copy" target="_blank">Protecting Your House and Storm Protection (Handouts)</a></li>
          <li><a href="https://docs.google.com/presentation/d/17Pix_VefJmmQ02U_5Pky5lvxx9EwQ0PksBe3jJt6_TQ/copy" target="_blank">Public Service Announcement Product Descriptor (Handout)</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>
        <h4 style="margin-left: 10px;">Videos</h4>
        <ul>
          <li><a href="https://drive.google.com/file/d/1ndkpIBve1CrA56ybV31fByldIfVCFPrn/view?usp=sharing" target="_blank">Lesson 2A: Air is All Around You Experiment</a></li>
          <li><a href="https://drive.google.com/file/d/1ndkEmrA3qhVvfOiZj-wzDOYSPKnQ8Vrc/view?usp=sharing" target="_blank">Lesson 2C: Variations in Air Temperature</a></li>
          <li><a href="https://drive.google.com/file/d/1QwGvLzw8nJoRaw6U6xrNpFVDttkOMXjg/view?usp=sharing" target="_blank">Lesson 3A: Water Jug with Holes</a></li>

        </ul>
      </div>

    </div>

  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
